import { useState } from "react";

import { Label, Radio, RadioGroup, RadioGroupOption } from "@headlessui/react";

import Modal from "../../layouts/Modal";
import { ISupplier } from "../../models/Supplier";
import classNames from "../../utils/classNames";
import AddEditSupplier from "./AddEditSupplier";

interface SuppliersModalProps {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    supplier?: ISupplier;
}

export default function SuppliersModal({ open, setOpen, supplier }: SuppliersModalProps) {
    return (
        <Modal width="max-w-3xl" open={open} setOpen={setOpen} >
            <AddEditSupplier supplier={supplier} setOpen={setOpen} />
        </Modal>
    )
}